import { JSX } from 'react'
import { closeSnackbar, enqueueSnackbar } from 'notistack'

import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { useListDialogStore } from '@/contexts/ListDialogContext'

export type NotifyErrorOptions = {
  details?: string[]
  title?: string
}

const showErrorSnackbar = (errorText: string, options?: NotifyErrorOptions) =>
  enqueueSnackbar(errorText, {
    variant: 'error',
    preventDuplicate: true,
    hideIconVariant: true,
    persist: true,
    action: (key): JSX.Element => {
      const handleViewDetails = () => {
        if (options?.details && useListDialogStore.show) {
          useListDialogStore.show({
            title: options.title || 'Error Details',
            items: options.details
          })
        }
        closeSnackbar(key)
      }

      return (
        <>
          {options?.details && options.details.length > 0 && (
            <Button color="inherit" variant="text" size="small" onClick={handleViewDetails}>
              View details
            </Button>
          )}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => closeSnackbar(key)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </>
      )
    },
    style: { whiteSpace: 'pre-line' }
  })

export function notifyError(errors: string | string[] | null, options?: NotifyErrorOptions) {
  if (Array.isArray(errors)) {
    errors.forEach((error: string) => {
      showErrorSnackbar(error, options)
    })
  } else if (errors) {
    showErrorSnackbar(errors, options)
  }
}
